import { ConnectorCategoryDlp } from '../api/governance/policy.model';
import { FilterTypesEnum } from '../filters/filterTypes.enum';
import { ISelectOption } from './selectOption.interface';

export const ConnectorCategorySelectOptions: ISelectOption[] = [
  {
    id: `${FilterTypesEnum.ConnectorCategory.toString()}-${ConnectorCategoryDlp.cloud.toString()}`,
    value: ConnectorCategoryDlp.cloud.toString(),
    displayName: 'Cloud Business Data',
    filterType: FilterTypesEnum.ConnectorCategory,
  },
  {
    id: `${FilterTypesEnum.ConnectorCategory.toString()}-${ConnectorCategoryDlp.communication.toString()}`,
    value: ConnectorCategoryDlp.communication.toString(),
    displayName: 'Communication',
    filterType: FilterTypesEnum.ConnectorCategory,
  },
  {
    id: `${FilterTypesEnum.ConnectorCategory.toString()}-${ConnectorCategoryDlp.highRisk.toString()}`,
    value: ConnectorCategoryDlp.highRisk.toString(),
    displayName: 'High Risk Connectors',
    filterType: FilterTypesEnum.ConnectorCategory,
  },
  {
    id: `${FilterTypesEnum.ConnectorCategory.toString()}-${ConnectorCategoryDlp.onPrem.toString()}`,
    value: ConnectorCategoryDlp.onPrem.toString(),
    displayName: 'On-Prem',
    filterType: FilterTypesEnum.ConnectorCategory,
  },
  {
    id: `${FilterTypesEnum.ConnectorCategory.toString()}-${ConnectorCategoryDlp.social.toString()}`,
    value: ConnectorCategoryDlp.social.toString(),
    displayName: 'Social Media Connectors',
    filterType: FilterTypesEnum.ConnectorCategory,
  },
  {
    id: `${FilterTypesEnum.ConnectorCategory.toString()}-${ConnectorCategoryDlp.unmanaged.toString()}`,
    value: ConnectorCategoryDlp.unmanaged.toString(),
    displayName: 'Unmanaged Cloud Endpoint',
    filterType: FilterTypesEnum.ConnectorCategory,
  },
];
